/**
 * Logger utility - only logs in development mode
 */

const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  log: (...args) => {
    if (isDev) console.log(...args);
  },
  
  error: (...args) => {
    if (isDev) console.error(...args);
  },
  
  warn: (...args) => {
    if (isDev) console.warn(...args);
  },
  
  info: (...args) => {
    if (isDev) console.info(...args);
  }
};

export default logger;
